import React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { CpsGridCell } from './CpsGridCell';
import { SvgIcon } from '@progress/kendo-react-common';
import { lockIcon, unlockIcon } from '@progress/kendo-svg-icons';

interface LockCellProps extends GridCustomCellProps {
  linked?: boolean;
  onLinkClicked?: () => void;
}

export const LockCell: React.FC<LockCellProps> = props => {
  const { linked, onLinkClicked } = props;
  const isLocked = Boolean(props.dataItem[props.field || '']);

  const title = isLocked ? 'Locked' : 'Unlocked';

  const handleClick = (e: React.MouseEvent) => {
    if (linked && onLinkClicked) {
      e.preventDefault();
      e.stopPropagation();
      onLinkClicked();
    }
  };

  return (
    <CpsGridCell
      dataItem={props.dataItem}
      field={props.field}
      dataIndex={props.dataIndex}
      id={props.id}
      tdProps={props.tdProps}
      columnPosition={props.columnPosition}
      onChange={props.onChange}
      className={linked ? 'k-grid-link-cell linked' : ''}
      colSpan={props.colSpan}
      ariaColumnIndex={props.ariaColumnIndex}
      isSelected={props.isSelected}
      style={props.style}
      rowType={props.rowType}
      level={props.level}
      expanded={props.expanded}
      title={title}
    >
      {linked ? (
        <a href="#" className="grid-link" onClick={handleClick}>
          <span className="lockedCell">
            <span className="linked-lock-cell">
              <SvgIcon
                icon={isLocked ? lockIcon : unlockIcon}
                size="large"
                themeColor={isLocked ? 'error' : 'success'}
              />
            </span>
          </span>
        </a>
      ) : (
        <span className="lockedCell">
          <SvgIcon icon={isLocked ? lockIcon : unlockIcon} size="large" themeColor={isLocked ? 'error' : 'success'} />
        </span>
      )}
    </CpsGridCell>
  );
};
